var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Top'),_c('Back'),_c('Model'),_c('RightNav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }